module.exports = __webpack_public_path__ + "assets/img/location-empty.6cf96018.png";